import React from 'react';
import { ExchangeForm } from './components/Exchange/ExchangeForm';

function App() {
  return <ExchangeForm />;
}

export default App;
